import styled from '@emotion/styled';
import * as RadixTooltip from '@radix-ui/react-tooltip';

import { Z_INDEX } from '@/constants/zIndex';

/* pds IconTooltip과 같은 생김새를 쓰되, 아이콘이 아닌 임의의 요소를 감쌀 수 있게 한다 */
export const Content = styled(RadixTooltip.Content)`
  z-index: ${Z_INDEX.tooltip};
  padding: 8px;
  background: ${({ theme }) => theme.colors.zinc_500};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.elevation.md};
`;
